export default "collect.a15c9cf9c07a2df4.svg"